<div class="app-footer">
  <div class="app-footer__inner">
    <div class="app-footer-left">
      <!-- <app-footer-dots></app-footer-dots> --> &nbsp;&nbsp;&nbsp;&nbsp;
      <a *ngIf="needHelp" class="mailto mb-2 mr-2 btn-icon btn-pill btn btn-success" href="mailto:help@savedesk.co"><i class="lnr-hand btn-icon-wrapper"> </i>Help / Support</a>
    </div>
    <div class="app-footer-right">
      @copyright  White Matter Advisory India Pvt Ltd, {{year}}
      <!-- <app-footer-menu></app-footer-menu> -->
    </div>
  </div>
</div>